import React from "react";
import CharacterPlayback from "./CharacterPlayback";

/**
 * Character plugin — plays a tagged pose/movement "story" (flipbook + motion +
 * mouth-sync) authored by the backend character-studio generator. Single file serves
 * both editor and visor; playback is deterministic in recorder mode via
 * props.visorCurrentTime (same pattern as AtomicBoxPlugin).
 */
export function Character(base) {
  return {
    getConfig() {
      return {
        name: "Character",
        displayName: "Character",
        category: "media",
        flavor: "react",
        needsConfigModal: false,
        needsTextEdition: false,
        initialWidth: "100%",
        initialHeight: "100%",
        icon: "person",
      };
    },

    getToolbar() {
      // Content is generated server-side; no interactive toolbar for now.
      return { main: { __name: "Character", accordions: {} } };
    },

    getInitialState() {
      return { characterId: "", sceneDurationSec: 0, segments: [] };
    },

    getRenderTemplate(state, props) {
      return (
        <CharacterPlayback
          state={state}
          boxId={props?.id || null}
          visor={props?.visor === true}
          visorCurrentTime={
            typeof props?.visorCurrentTime === "number" ? props.visorCurrentTime : null
          }
          recorderMode={props?.recorderMode === true}
          timeOriginSec={props?.animationTimeOriginSec ?? null}
          sceneId={
            Array.isArray(props?.currentView)
              ? props.currentView[props.currentView.length - 1]
              : props?.currentView
          }
          visorPlaying={props?.sceneAdvancing ?? props?.visorPlaying}
        />
      );
    },
  };
}
